import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateOverview = document.createElement('template');

templateOverview.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-full-width-height-2">
    <div class="item" gz-overview="managedEndpoints">
        <div class="item-content">
          <h2 class="item--title display-2 widget-title">
            <span id="managedEndpointsTitle"></span>
            ${renderErrorStateIcon()}
          </h2>
          <div class="item-values">
            <span gz-overview-field="value" class="item--value"></span>
            <span gz-overview-field="delta" class="item--delta"></span>
          </div>

          <div class="widget-empty gz-info-message">
            <div class="message-container">
            </div>
            <div id="installButtonsContainer"></div>
          </div>

          <gz-loader class="widget-loading" rows="1"></gz-loader>
        </div>
        <div id="managedEndpointsEmpty" class="message body-copy">
            <div id="managedEndpointsTextContainer">
                <gz-text fontSize="11" class="managedEndpointsText"></gz-text>
            </div>
            <div id="managedEndpointsButtons"></div>
        </div>
        <div id="managedEndpointsActions"></div>
    </div>
    <div class="item" gz-overview="activeEndpoints">
      <div class="item-content">
        <h2 class="item--title display-2 widget-title">
            <span id="activeEndpointsTitle"></span>
            ${renderErrorStateIcon()}
        </h2>
        <div class="item-values">
          <span gz-overview-field="value" class="item--value"></span>
        </div>

        <gz-loader class="widget-loading" rows="1"></gz-loader>
      </div>
    </div>
    <div class="item" gz-overview="threatsBlocked">
        <div class="item-content">
        <h2 class="item--title display-2 widget-title">
            <span id="threatsBlockedTitle"></span>
            ${renderErrorStateIcon()}
        </h2>
        <div class="item-values">
          <span gz-overview-field="value" class="item--value"></span>
          <span gz-overview-field="delta" class="item--delta"></span>
        </div>

         <gz-loader class="widget-loading" rows="1"></gz-loader>
      </div>
    </div>
    <div class="item" gz-overview="companyScore">
      <div class="item-content">
        <h2 class="item--title display-2 widget-title">
            <span id="companyScoreTitle"></span>
            ${renderErrorStateIcon()}
        </h2>
        <div class="item-values">
          <span gz-overview-field="value" class="item--value"></span>
          <span gz-overview-field="delta" class="item--delta"></span>
        </div>

         <gz-loader class="widget-loading" rows="1"></gz-loader>
      </div>
    </div>
  </div>
`;
